  /* eslint-disable */

class stickySidebar {
  constructor({el, sidebar, sidebarWrapper, bottomRow, intro}) {
    this.section = {el: el};
    this.sidebar = sidebar;
    this.sidebarWrapper = sidebarWrapper;
    this.bottom = bottomRow;
    this.intro = intro;
    // this.pageBool = pageBool;
    // this.observer = observer;

    this.changeSidebar();
    // this.clickToEl();

    // if (this.observer.bool) {
    //   this.activeObserver();
    // }
  }

  changeSidebar() {
    let sidebar = this.sidebar;
    let section = this.section;
    let bottom = this.bottom;
    let wrapper = this.sidebarWrapper;
    let intro = this.intro;
    // let pageBool = this.pageBool;

    this.scrollPoint = () => {

      if (window.innerWidth > 1024) {
        // Window scroll
        let scroll = window.pageYOffset;

        let bottomLimit, topLimit, paddingTop, introBottom;
        // let header = 74;

        // Get section padding
        let getStyle = window.getComputedStyle(section.el);
        let paddingBottom = getStyle.getPropertyValue('padding-bottom');
        paddingBottom = parseInt(paddingBottom, 10);

        paddingTop = getStyle.getPropertyValue('padding-top');
        paddingTop = parseInt(paddingTop, 10);

        let introPadding = window.getComputedStyle(intro);
        introBottom = introPadding.getPropertyValue('padding-bottom');
        introBottom = parseInt(introBottom, 10);

        // topLimit = (section.el.offsetTop + paddingTop + introBottom) + 10;
        topLimit = (section.el.offsetTop + paddingTop + introBottom);
        bottomLimit = (bottom.offsetTop  - paddingBottom) - sidebar.clientHeight + 45;
        // bottomLimit = (bottom.offsetTop  - paddingBottom) - sidebar.clientHeight;

        // Start
        // if ( scroll - header >= topLimit) {
        if ( scroll>= topLimit) {
          sidebar.classList.add('fixed-sidebar');
          wrapper.classList.remove('hide-sidebar');
          // sidebar.style.top = header + paddingTop + 'px';
          // sidebar.style.top = (paddingTop + paddingPt) + 'px';
          sidebar.style.top = (paddingTop) + 'px';
          // sidebar.style.top = (introBottom + 1) + 'px';
        }

        // Reaches top
        // else if ( scroll - header <= topLimit) {
        else if ( scroll <= topLimit) {
          sidebar.classList.remove('fixed-sidebar');
          sidebar.style = '';
        }

        // Start bottom
        // if (scroll - header > bottomLimit) {
        if (scroll > bottomLimit) {
          sidebar.classList.add('bottom');
          sidebar.style.top = 'auto';
          sidebar.classList.remove('fixed-sidebar');

        }

        // Leaving bottom
        // if (scroll - header <= bottomLimit) {
        if (scroll <= bottomLimit) {
          sidebar.classList.remove('bottom');
        }
      }
      else {
        sidebar.setAttribute('style', '');
        sidebar.classList = 'g-1 social-list vertical';
      }
    }

    window.addEventListener('scroll', event => {
        this.scrollPoint(event);
    });

    // window.addEventListener('resize', event => {
    //     this.scrollPoint(event);
    // });
  }

  activeObserver() {
    let sidebar = this.sidebar.querySelectorAll('a');
    let content = this.observer;
    let pageBool = this.pageBool;

    let options = {};

    if (pageBool == 'legal') {
      options = {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -80% 0px',
      }
    } else {
      options = {
        root: null,
        threshold: 0.2,
        rootMargin: '0px 0px -60% 0px',
      }
    }

    // eslint-disable-next-line
    let callback = function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          sidebar.forEach(a => {
            a.classList.remove('active');
            if (a.dataset.anchor == entry.target.id) {
              a.classList.add('active')
            }
          })
        }
      })
    }

    let observer = new IntersectionObserver(callback, options);

    let sections = document.querySelectorAll(content.sections);
    Array.prototype.forEach.call((sections), el => {
      observer.observe(el);
    })
  }

  clickToEl() {
    let sidebar = this.sidebar;
    let links = sidebar.querySelectorAll('a');

    links.forEach(link => {
      link.addEventListener('click', changeActive)
    });

    // Force active
    function changeActive(event) {
      event.preventDefault();

      links.forEach(link => link.classList.remove('active'));
      event.target.classList.add('active');
    }
  }
}
export default stickySidebar;



// WEBPACK FOOTER //
// ./scripts/components/stickySidebar.js